<template>
  <div>
    <div v-if="!afficherRecomArchi" class="level-item is-size-6">
      <a class="is-underline has-text-primary" @click="actionAfficherRecomCommande">
        {{ nameLienAfficherRecoCommande }}
      </a>
    </div>
    <div class="level-item is-size-6">
      <a class="is-underline has-text-primary" @click="afficherRecom">
        {{ nameLienAfficherRecoArchive }}
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LiensActions',
  props: {
    afficherRecomArchi: {
      type: Boolean,
      default: false
    },
    afficherRecomCommande: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    nameLienAfficherRecoArchive() {
      const key = this.afficherRecomArchi ? 'masquerRecomArchivees' : 'afficherRecomArchivees';
      return this.$t(`tableauDeBord.${key}`);
    },
    nameLienAfficherRecoCommande() {
      const key = this.afficherRecomCommande ? 'masquerRecomCommandees' : 'afficherRecomCommandees';
      return this.$t(`tableauDeBord.${key}`);
    },
  },
  methods: {
    afficherRecom() {
      this.$emit('update:afficherRecomArchi', !this.afficherRecomArchi);
      this.$emit('update:afficherRecomCommande', false);
      this.$emit('filtreChange');
    },
    actionAfficherRecomCommande() {
      this.$emit('update:afficherRecomCommande', !this.afficherRecomCommande);
      this.$emit('filtreChange');
    },
  },
}
</script>
